import { AlarmRule } from 'src/features/alarm-rules/types';
import { AlarmDataV3 } from 'src/types/alarms';

export function initializeAlarmData() {
  const initialAlarmData: AlarmDataV3 = {
    id: '',
    status: '',
    title: '',
    priority: '',
    siteId: '',
    description: '',
    ruleId: '',
    siteName: '',
    assets: [{ id: '', name: '', type: '' }],
    gateway: { id: '', name: '' },
    mainTag: { name: '', limit: '', value: 0 },
    additionalTag: { name: '', limit: '', value: 0 },
    startDate: '',
    endDate: '',
    durationInSeconds: '',
    acknowledgment: { firstName: '', lastName: '', userId: '', timestamp: '' },
  };
  return initialAlarmData;
}

export function initializeAlarmRule() {
  const initialAlarmRule: AlarmRule = new AlarmRule(
    '',
    '',
    '',
    '',
    '',
    0,
    {
      tagId: '',
      tagName: '',
      tagConnectedAsset: '',
    },
    'Critical'
  );

  return initialAlarmRule;
}
